import React, { ReactNode } from "react";
import { Layout, Button } from "antd";
import Breadcrumbs from "./Breadcrumb";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const { Header: AntHeader } = Layout;

interface HeaderProps {
  collapsed: boolean;
  setCollapsed?: (collapsed: boolean) => void;
  children?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  collapsed,
  setCollapsed,
  children,
}) => {

  return (
    <AntHeader className="site-header bg-white px-4 md:px-6 flex justify-between items-center shadow-sm">
      <div className="header-left flex items-center gap-4">
        {/* <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed?.(!collapsed)}
          className="text-lg flex items-center justify-center h-10 w-10"
        /> */}
        <div className="overflow-hidden">
          <Breadcrumbs />
        </div>
      </div>
      <div className="header-right flex items-center gap-2 md:gap-4 overflow-hidden">
        <div className="flex-shrink-0">
          {children}
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;